/* Kratus × Eclipse — globo (popover) de "Ordenar" de la colección. [E5]
   Reemplaza el enfoque anterior (E4.2: el segmento "Orden" de la píldora abría el drawer de
   filtros y hacía scroll+foco al <select> que vivía dentro). Desde que el panel separa
   filtrar/ordenar, "Ordenar" es su propio control: un único popover con radios reales,
   disparado por dos triggers (data-eclipse-sort-trigger) — el control de arriba en desktop y
   el segmento "Orden" de la píldora sticky en cualquier ancho.

   Fuente de verdad: <select id="SortBy-mobile"> (vive dentro de #FacetFiltersFormMobile). Se
   eligió ESE select y no el de arriba (#SortBy, en un <form> propio FacetSortDrawerForm)
   porque #FacetFiltersFormMobile es el único formulario que ya trae TODOS los filtros activos
   además del orden — enviar el cambio de orden a través de él evita el bug preexistente de
   Dawn donde cambiar el <select> de arriba solo mandaba `sort_by` y tiraba los filtros
   aplicados (confirmado en vivo antes de este cambio). No se toca facets.js: se dispara
   change+input sobre el <select> real, exactamente como si el usuario lo hubiera usado a
   mano. */
(function () {
  if (window.__eclipseSortPopoverBound) {
    return;
  }
  window.__eclipseSortPopoverBound = true;

  var popoverEl = null;
  var currentTrigger = null;

  function getSourceSelect() {
    return document.getElementById('SortBy-mobile');
  }

  function buildPopover() {
    var el = document.createElement('div');
    el.className = 'eclipse-sort-popover';
    el.setAttribute('role', 'radiogroup');
    el.setAttribute('aria-label', 'Ordenar por');
    el.hidden = true;
    document.body.appendChild(el);
    return el;
  }

  function renderOptions() {
    var select = getSourceSelect();
    if (!select) return;
    popoverEl.innerHTML = '';
    Array.prototype.forEach.call(select.options, function (option, index) {
      var id = 'EclipseSortOption-' + index;
      var wrapper = document.createElement('label');
      wrapper.className = 'eclipse-sort-popover__option';
      wrapper.setAttribute('for', id);

      var input = document.createElement('input');
      input.type = 'radio';
      input.id = id;
      input.name = 'eclipse-sort-radio';
      input.value = option.value;
      input.checked = option.selected;

      var text = document.createElement('span');
      text.textContent = option.text;

      wrapper.appendChild(input);
      wrapper.appendChild(text);
      popoverEl.appendChild(wrapper);
    });
  }

  function positionPopover(trigger) {
    var rect = trigger.getBoundingClientRect();
    var width = popoverEl.offsetWidth || 240;
    var left = rect.left;
    if (left + width > window.innerWidth - 8) {
      left = window.innerWidth - width - 8;
    }
    if (left < 8) left = 8;

    // Tope vertical: el disparador de la píldora sticky vive pegado al fondo del viewport, así
    // que el caso normal es que abrir hacia ABAJO no quepa. Si no cabe abajo, se abre hacia
    // arriba; si tampoco cabe arriba (viewport muy bajo), se pega al borde superior con el mismo
    // margen de 8px que ya usa la lógica horizontal. offsetHeight ya viene acotado por el
    // max-height:60vh del CSS, y aquí es válido porque se llama después de popoverEl.hidden = false.
    var height = popoverEl.offsetHeight || 0;
    var top = rect.bottom + 8;
    if (top + height > window.innerHeight - 8) {
      var above = rect.top - height - 8;
      top = above >= 8 ? above : Math.max(8, window.innerHeight - height - 8);
    }

    popoverEl.style.top = top + 'px';
    popoverEl.style.left = left + 'px';
  }

  function openPopover(trigger) {
    if (!popoverEl) popoverEl = buildPopover();
    renderOptions();
    popoverEl.hidden = false;
    currentTrigger = trigger;
    trigger.setAttribute('aria-expanded', 'true');
    positionPopover(trigger);
    var firstChecked = popoverEl.querySelector('input:checked') || popoverEl.querySelector('input');
    if (firstChecked) firstChecked.focus();
  }

  function closePopover() {
    if (!popoverEl || popoverEl.hidden) return;
    popoverEl.hidden = true;
    if (currentTrigger) {
      currentTrigger.setAttribute('aria-expanded', 'false');
      currentTrigger.focus();
    }
    currentTrigger = null;
  }

  function applySort(value) {
    var select = getSourceSelect();
    closePopover();
    if (!select || select.value === value) return;
    select.value = value;
    select.dispatchEvent(new Event('change', { bubbles: true }));
    select.dispatchEvent(new Event('input', { bubbles: true }));
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-eclipse-sort-trigger]');
    if (trigger) {
      event.preventDefault();
      if (popoverEl && !popoverEl.hidden && currentTrigger === trigger) {
        closePopover();
      } else {
        openPopover(trigger);
      }
      return;
    }

    var option = event.target.closest('.eclipse-sort-popover__option');
    if (option) {
      var input = option.querySelector('input');
      if (input) applySort(input.value);
      return;
    }

    if (popoverEl && !popoverEl.hidden && !event.target.closest('.eclipse-sort-popover')) {
      closePopover();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && popoverEl && !popoverEl.hidden) {
      closePopover();
    }
  });

  window.addEventListener('resize', function () {
    if (popoverEl && !popoverEl.hidden && currentTrigger) positionPopover(currentTrigger);
  });

  window.addEventListener(
    'scroll',
    function () {
      if (popoverEl && !popoverEl.hidden && currentTrigger) positionPopover(currentTrigger);
    },
    true,
  );
})();
